import * as React from 'react';
import * as moment from 'moment';

import { IInputChangeEventHandler } from '../../interfaces';

import RangeCalendar = require('rc-calendar/lib/RangeCalendar');
import Picker = require('rc-calendar/lib/Picker');

interface IProps {
    start: number,
    end: number,
    handleChange: IInputChangeEventHandler,
}

interface IState {
    value: any[]
}

export default class RangeDatePicker extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = this.getNewState(props);
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (this.props !== nextProps) {
            this.setState(this.getNewState(nextProps));
        }
    }

    getNewState(props) {
        return {
            value: [moment(props.start), moment(props.end)]
        };
    }

    onChange(value) {
        const msValue = value.map(v => v.valueOf());

        this.props.handleChange('dateRange', msValue);
        this.setState({ value });
    }

    renderDates(values) {
        return values.map(value => {
            return value.format('LL');
        }).join(' - ');
    }

    render() {
        const state = this.state;

        const calendar = (
            <RangeCalendar
                showWeekNumber={false}
                dateInputPlaceholder={['start', 'end']}
                />
        );

        return (
            <Picker
                value={state.value}
                onChange={this.onChange.bind(this)}
                animation="slide-down"
                calendar={calendar}
                >
                {
                    ({ value }) => {
                        return (<span>
                            <input
                                placeholder="please select"
                                style={{ width: 350 }}
                                readOnly
                                className="ant-calendar-picker-input ant-input form-control"
                                value={this.renderDates(value)}
                                />
                        </span>);
                    }
                }
            </Picker>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/reportSettings/RangeDatePicker.tsx